var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 164,
    viewBox: "0 0 165 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.65,
    cx: 82.378,
    cy: 81.753,
    r: 81.753,
    fill: "#54D4BD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.3789,
    cy: 81.7529,
    r: 68.7304,
    fill: "#54D4BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9195 78.7684C101.159 79.5642 101.913 80.966 101.913 82.4762C101.913 83.9865 101.159 85.3882 99.9195 86.1027L74.9621 102.019C73.6777 102.914 72.07 102.951 70.7579 102.182C70.113 101.804 69.5762 101.254 69.2027 100.588C68.8292 99.9222 68.6325 99.1644 68.6328 98.3927V66.5597C68.6329 65.7885 68.8298 65.0312 69.2033 64.3658C69.5768 63.7003 70.1134 63.1506 70.7579 62.7732C71.4025 62.3962 72.1318 62.2051 72.8707 62.2195C73.6096 62.234 74.3314 62.4535 74.9621 62.8555L99.9195 78.7684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/Play Button.1d74844520687822e6ed7cd5bffde7b7.svg";
export { ForwardRef as ReactComponent };